<template>
  <button v-bind="$attrs" :class="[fillStyle, colorStyle]"><slot /></button>
</template>

<script>
  export default {
    name: 'recyco-button',
    props: {
      fillStyle: {
        type: String,
        default: 'solid',
        validator: (style) => ['solid', 'ghost'].includes(style),
      },
      colorStyle: {
        type: String,
        default: 'primary',
        validator: (color) => ['primary', 'inverted', 'danger'].includes(color),
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/mixins.scss';

  button {
    font: inherit;
    padding: .4375em .75em;
    line-height: 1.5;
    // will-change: filter, box-shadow;
    will-change: filter;
    border-radius: 1.5em;
    box-shadow: none;
    outline: 0;
    // transition: box-shadow .25s cubic-bezier(.27, .01, .38, 1.06), filter .25s cubic-bezier(.27, .01, .38, 1.06), -webkit-box-shadow .25s cubic-bezier(.27, .01, .38, 1.06);
    transition: filter .25s cubic-bezier(.27, .01, .38, 1.06);
    cursor: pointer;

    // &:enabled:hover {
    //   box-shadow: 0 .313rem .719rem rgba(var(--color-primary), .2), 0 .156rem .125rem rgba(0, 0, 0, .06); // TODO Inveritrlo si el fondo es blanco
    // }

    user-select: none;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: transparent;

    @include drop-shadow();

    &:disabled {
      cursor: not-allowed;
    }
  }

  .solid {
    border: none;

    &:enabled:hover {
      filter: brightness(1.05);
    }

    &:enabled:active {
      filter: brightness(0.95);
    }

    &.primary {
      background-color: var(--color-primary);
      color: white;
    }

    &.inverted {
      background-color: var(--color-background);
      color: var(--color-primary);
    }

    &.danger {
      background-color: var(--color-danger);
      color: white;
    }
  }

  .ghost {
    border-width: 1px;
    border-style: solid;
    background-color: transparent;
    will-change: color, background-color, border-color;
    transition: color .25s cubic-bezier(.27, .01, .38, 1.06), background-color .25s cubic-bezier(.27, .01, .38, 1.06), border-color .25s cubic-bezier(.27, .01, .38, 1.06);

    &:enabled:active {
      filter: brightness(0.95);
    }
  }

  .ghost.primary {
    border-color: var(--color-primary);
    color: var(--color-primary);

    &:enabled:hover {
      background-color: var(--color-primary);
      color: var(--color-background);
    }
  }

  .ghost.inverted {
    border-color: var(--color-background);
    color: var(--color-background);

    &:enabled:hover {
      background-color: var(--color-background);
      color: var(--color-primary);
    }
  }

  .ghost.danger {
    border-color: var(--color-danger);
    color: var(--color-danger);

    &:enabled:hover {
      background-color: var(--color-danger);
      color: var(--color-background);
    }
  }
</style>
